import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table, TableBody, TableCell, TableHead,
  TableRow, TextField, Box, FormControlLabel, RadioGroup,
  Typography, FormControl,
} from '@material-ui/core';
import {
  CHAR_CODE_MATCHING,
  DELIMITER_MATCHING,
} from '../../../common/const';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import {
  setSystemLodingFLg,
  setInitMessage,
  setErrorMessage,
} from '../../actions/CommonAction';
import {
  setDispTab,
  fileUploadExecute,
  setErrMatchingFile,
  setUploadMemo,
  setCharCode,
  setDelimiter,
  setErrUploadMemoFlg,
  setErrUploadMemoMsg,
} from '../../actions/MatchingAction';
import validator from '../../../common/validator';
import styles from './MatchingSettingComponent.module.css';
import CustomRadio from '../common/CustomRadio';

class MatchingSettingComponent extends Component {
  /**
   * コンポーネント生成時の処理
   */
  componentDidMount = async () => {
    const {
      setInitMessageAct,
      setErrMatchingFileAct,
      setErrUploadMemoFlgAct,
      setErrUploadMemoMsgAct,
      setUploadMemoAct,
      setCharCodeAct,
      setDelimiterAct,
    } = this.props;
    // 初期化
    setInitMessageAct();
    setErrMatchingFileAct(false);
    setErrUploadMemoFlgAct(false);
    setUploadMemoAct(null);
    setCharCodeAct(CHAR_CODE_MATCHING.SJIS);
    setDelimiterAct(DELIMITER_MATCHING.COMMA);
    setErrUploadMemoMsgAct('');
  }

  /**
   * アップロードメモのチェック
   */
  checkUploadMemo = () => {
    const {
      setInitMessageAct,
      uploadMemo,
      setErrUploadMemoFlgAct,
      setErrUploadMemoMsgAct,
    } = this.props;
    setInitMessageAct();
    const msgs = [];
    // アップロードメモの文字数チェック
    validator.checkMaxLength(uploadMemo, 50, msgs);
    // 文字数エラーがあった場合、エラーメッセージ表示
    if (msgs.length !== 0) {
      setErrUploadMemoFlgAct(true);
      setErrUploadMemoMsgAct(getMessage(ERROR.E08009, msgs.join(',')));
      return;
    }
    setErrUploadMemoFlgAct(false);
    setErrUploadMemoMsgAct('');
  }

  // ファイルクリック
  onClickFile = () => {
    const file = document.getElementById('matchingFile');
    file.click();
  }

  // ファイル選択
  onChangeFile = () => {
    const {
      setErrMatchingFileAct,
    } = this.props;
    const file = document.getElementById('matchingFile').files[0];
    if (file !== undefined) {
      document.getElementById('filemessage').innerText = file.name;
    } else {
      document.getElementById('filemessage').innerText = '選択されていません';
    }
    setErrMatchingFileAct(false);
  }

  render() {
    const {
      errMatchingFile,
      errUploadMemoFlg,
      errUploadMemoMsg,
      charCode,
      delimiter,
      setUploadMemoAct,
      setCharCodeAct,
      setDelimiterAct,
      uploadMemo,
    } = this.props;
    return (
      <Box className={`${styles.matchingsetting}`}>
        <Box display="flex" alignItems="center" flexDirection="column" className={`${styles.matchingsettingframe}`}>
          <Table className={`${styles.matchingsettingfield}`}>
            <TableHead className={`${styles.header}`}>
              <TableRow>
                <TableCell className={`${styles.headerTitle} ${styles.topRadius}`}>マッチング設定</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={`${styles.row}`}>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.rowTitle}`}>アップロードメモ</Typography>
                    <Box className={`${styles.item}`}>
                      <TextField
                        variant="outlined"
                        value={uploadMemo || ''}
                        onChange={(ev) => setUploadMemoAct(ev.target.value)}
                        onBlur={this.checkUploadMemo}
                        InputProps={{
                          classes: {
                            root: styles.outLinedInput,
                            input: styles.inputSizing,
                            notchedOutline: errUploadMemoFlg
                              ? styles.inputErrorBoderColor
                              : styles.notchedOutline,
                          },
                        }}
                        error={errUploadMemoFlg}
                      />
                      {errUploadMemoFlg && (
                        <div className={`${styles.baloon}`}>
                          <div className={`${styles.triangle}`}>
                            <div className={`${styles.triangleDiv}`} />
                          </div>
                          <div className={`${styles.babble}`}>
                            {errUploadMemoMsg}
                          </div>
                        </div>
                      )}
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow className={`${styles.row}`}>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.rowTitle}`}>文字コード</Typography>
                    <Box>
                      <FormControl component="fieldset">
                        <RadioGroup row>
                          <FormControlLabel
                            value={CHAR_CODE_MATCHING.SJIS}
                            control={<CustomRadio />}
                            label="Shift-JIS"
                            checked={charCode === CHAR_CODE_MATCHING.SJIS}
                            onChange={() => setCharCodeAct(CHAR_CODE_MATCHING.SJIS)}
                          />
                          <FormControlLabel
                            value={CHAR_CODE_MATCHING.UTF8}
                            control={<CustomRadio />}
                            label="UTF-8"
                            checked={charCode === CHAR_CODE_MATCHING.UTF8}
                            onChange={() => setCharCodeAct(CHAR_CODE_MATCHING.UTF8)}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow className={`${styles.row}`}>
                <TableCell className={`${styles.bottomRadius}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.rowTitle}`}>区切り文字</Typography>
                    <Box>
                      <FormControl component="fieldset">
                        <RadioGroup row>
                          <FormControlLabel
                            value={DELIMITER_MATCHING.COMMA}
                            control={<CustomRadio />}
                            label="カンマ"
                            checked={delimiter === DELIMITER_MATCHING.COMMA}
                            onChange={() => setDelimiterAct(DELIMITER_MATCHING.COMMA)}
                          />
                          <FormControlLabel
                            value={DELIMITER_MATCHING.TAB}
                            control={<CustomRadio />}
                            label="タブ"
                            checked={delimiter === DELIMITER_MATCHING.TAB}
                            onChange={() => setDelimiterAct(DELIMITER_MATCHING.TAB)}
                            className={`${styles.radioTab}`}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Table className={`${styles.matchingsettingfield}`}>
            <TableHead className={`${styles.header}`}>
              <TableRow>
                <TableCell className={`${styles.headerTitle} ${styles.topRadius}`}>設定ファイル</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={`${styles.matchingFile}`}>
                <TableCell className={`${styles.bottomRadius} ${styles.settingFileCell}`}>
                  <Box className={`${styles.condition}`}>
                    <Box className={`${styles.fileSelectBtn}`}>
                      <button
                        type="button"
                        className={`${styles.fileButton}`}
                        onClick={() => this.onClickFile()}
                      >
                        ファイルを選択
                      </button>
                      <input type="file" id="matchingFile" onChange={() => this.onChangeFile()} className={errMatchingFile ? `${styles.inputError} ${styles.inputMatchingfile}` : `${styles.inputMatchingfile}`} />
                    </Box>
                    <Box className={`${styles.fileSelectStatus}`}>
                      <span id="filemessage" className={errMatchingFile ? `${styles.inputError} ${styles.fileMassage}` : `${styles.fileMassage}`}>選択されていません</span>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    dispTab: state.matching.dispTab,
    selectSequenceId: state.matching.selectSequenceId,
    errMatchingFile: state.matching.errMatchingFile,
    uploadMemo: state.matching.uploadMemo,
    charCode: state.matching.charCode,
    delimiter: state.matching.delimiter,
    errUploadMemoFlg: state.matching.errUploadMemoFlg,
    errUploadMemoMsg: state.matching.errUploadMemoMsg,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrorMessageAct: (errorMessage) => dispatch(setErrorMessage(errorMessage)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setDispTabAct: (str) => dispatch(setDispTab(str)),
    setUploadMemoAct: (str) => dispatch(setUploadMemo(str)),
    setCharCodeAct: (str) => dispatch(setCharCode(str)),
    setDelimiterAct: (str) => dispatch(setDelimiter(str)),
    setErrMatchingFileAct: (bool) => dispatch(setErrMatchingFile(bool)),
    setErrUploadMemoFlgAct: (bool) => dispatch(setErrUploadMemoFlg(bool)),
    setErrUploadMemoMsgAct: (str) => dispatch(setErrUploadMemoMsg(str)),
    fileUploadExecuteAct: (
      uploadFile,
      uploadMemo,
      charCode,
      delimiter,
    ) => dispatch(fileUploadExecute(
      uploadFile,
      uploadMemo,
      charCode,
      delimiter,
    )),
  }),
)(MatchingSettingComponent);
